var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "left-banner",
      class: _vm.widthNav ? "widthNav" : "",
      attrs: { id: "leftBan", "data-nonedrive": _vm.noneDrive ? "yes" : "no" }
    },
    [
      _c(
        "div",
        {
          staticClass: "cloud-icon",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toMainHomePage()
            }
          }
        },
        [
          _c("div", { staticClass: "cloud-icon-position" }, [
            _c("div", { staticClass: "cloud-image" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cloud-description",
                style: {
                  fontSize: this.$i18n.locale != "english" ? "10Px" : ""
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.leftBanner.logoSlogan")))]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "navigation-menu" }, [
        _vm.topNavIndex == 1 || _vm.topNavIndex == 0
          ? _c(
              "div",
              {
                staticClass: "manage_clouds_left",
                class: _vm.widthNav ? "manage_clouds_select" : "",
                on: {
                  click: function($event) {
                    return _vm.showWidthNav()
                  }
                }
              },
              [
                _c("div"),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    attrs: {
                      title: _vm.$store.state.isLiteMode
                        ? _vm.$t("language.leftBanner.manageClouds2")
                        : _vm.$t("language.leftBanner.manageClouds")
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$store.state.isLiteMode
                          ? _vm.$t("language.leftBanner.manageClouds2")
                          : _vm.$t("language.leftBanner.manageClouds")
                      )
                    )
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "menu-option-title" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.$t("language.leftBanner.commonTools")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "function-menu menu-options",
            attrs: { id: "functionMenu" }
          },
          [
            _vm._l(_vm.menuOptions, function(option) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.checkMenuShow(option),
                      expression: "checkMenuShow(option)"
                    }
                  ],
                  key: option.id,
                  staticClass: "menu-option",
                  class:
                    option.id == _vm.menuClickCurrent
                      ? "menu-option-select"
                      : "",
                  attrs: { id: option.id == 100 ? "taskList" : null },
                  on: {
                    click: function($event) {
                      return _vm.menuOptionSelect(option.id)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon",
                    class:
                      option.id == _vm.menuClickCurrent
                        ? option.icon
                        : option.icon
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-name" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("language.leftBanner." + option.name)) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  option.hasNewNum && _vm.getMenuOptionNewNum(option.hasNewNum)
                    ? _c("div", { staticClass: "option-num" }, [
                        _vm._v(
                          _vm._s(_vm.getMenuOptionNewNum(option.hasNewNum))
                        )
                      ])
                    : _vm._e()
                ]
              )
            }),
            _vm._v(" "),
            _vm.$store.state.beginGuideFlag &&
            _vm.guideStepOne &&
            !_vm.$store.state.isLiteMode
              ? _c("div", { staticClass: "step-one" }, [
                  _c("div", { staticClass: "bubble bubble-one-position" }, [
                    _c("div", { staticClass: "bubble-triangle" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util bubble-close",
                      staticStyle: { float: "right" },
                      on: {
                        click: function($event) {
                          return _vm.cancelGuide()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bubble-text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.leftBanner.createTaskText"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "bubble-button",
                        on: {
                          click: function($event) {
                            return _vm.nextStepTwo()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.popup.reportPopup.next"))
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.insGuideFlag && _vm.guideStepIns
              ? _c("div", { staticClass: "step-ins" }, [
                  _c("div", { staticClass: "bubble bubble-one-position" }, [
                    _c("div", { staticClass: "bubble-triangle" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util bubble-close",
                      staticStyle: { float: "right" },
                      on: {
                        click: function($event) {
                          return _vm.closeInsGuide()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bubble-text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.imageSaver.noviceGuidance"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "bubble-button",
                        on: {
                          click: function($event) {
                            return _vm.closeInsGuide()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.leftBanner.gotIt")))]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.googleGuideFlag && _vm.guideStepGoogle
              ? _c("div", { staticClass: "step-google-photos-v2-tips-box" }, [
                  _c(
                    "div",
                    {
                      staticClass: "step-google-photos-v2-tips",
                      attrs: { language: this.$i18n.locale }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bubble bubble-google-position" },
                        [
                          _c("div", { staticClass: "bubble-triangle" }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "icon-util bubble-close",
                            staticStyle: { float: "right" },
                            on: {
                              click: function($event) {
                                return _vm.closeGoogleGuide()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "bubble-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.cloudExploerPopup.googlePhotosV2AddMoreTips"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "bubble-button",
                              on: {
                                click: function($event) {
                                  return _vm.closeGoogleGuide()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.googleGuideFlag2 && _vm.guideStepGoogle2
              ? _c("div", { staticClass: "step-google-photos-v2-tips-box2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "step-google-photos-v2-tips2",
                      style: _vm.bubbleStyle2
                    },
                    [
                      _c("div", { staticClass: "add-more-photos-icon" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bubble bubble-google-position2" },
                        [
                          _c("div", { staticClass: "bubble-triangle" }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "icon-util bubble-close",
                            staticStyle: { float: "right" },
                            on: {
                              click: function($event) {
                                return _vm.closeGoogleGuide2()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "bubble-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.cloudExploerPopup.googlePhotosV2AddMoreTips"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "bubble-button",
                              on: {
                                click: function($event) {
                                  return _vm.closeGoogleGuide2()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.topNavIndex != 1 && _vm.topNavIndex != 0
          ? _c("div", { staticClass: "menu-option-title" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("language.leftBanner.onlineServices")) +
                  "\n\t\t\t"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "add-menu menu-options", attrs: { id: "addMenu" } },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.topNavIndex != 1 && _vm.topNavIndex != 0,
                    expression: "topNavIndex!=1&&topNavIndex!=0"
                  }
                ],
                staticClass: "menu-option",
                class: 901 == _vm.menuClickCurrent ? "menu-option-select" : "",
                on: {
                  click: function($event) {
                    return _vm.menuOptionSelect(901)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "icon",
                  class:
                    901 == _vm.menuClickCurrent
                      ? "addCloudIcon"
                      : "addCloudIcon-black"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "option-name" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("language.common.addCloud")) +
                      "\n\t\t\t\t\t"
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.tabCategories == 1
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.topNavIndex != 1 &&
                          _vm.topNavIndex != 0 &&
                          !_vm.$store.state.isLiteMode,
                        expression:
                          "topNavIndex!=1&&topNavIndex!=0&&!$store.state.isLiteMode"
                      }
                    ],
                    staticClass: "menu-option",
                    class:
                      902 == _vm.menuClickCurrent ? "menu-option-select" : "",
                    on: {
                      click: function($event) {
                        return _vm.menuOptionSelect(902)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon",
                      class:
                        902 == _vm.menuClickCurrent
                          ? "addEmailIcon"
                          : "addEmailIcon-black"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-name" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("language.common.addEmail")) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasTeam && _vm.hasTeam.id
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.$store.state.isLiteMode,
                        expression: "!$store.state.isLiteMode"
                      }
                    ],
                    staticClass: "menu-option",
                    class:
                      903 == _vm.menuClickCurrent || 8 == _vm.menuClickCurrent
                        ? "menu-option-select"
                        : "",
                    on: {
                      click: function($event) {
                        return _vm.menuOptionSelect(903)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon",
                      class:
                        903 == _vm.menuClickCurrent || 8 == _vm.menuClickCurrent
                          ? "team-white-small"
                          : "team-white-small"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-name" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("language.common.team")) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.beginGuideFlag &&
            _vm.guideStepTwo &&
            !_vm.$store.state.isLiteMode
              ? _c("div", { staticClass: "step-two" }, [
                  _c("div", { staticClass: "bubble bubble-two-position" }, [
                    _c("div", { staticClass: "bubble-triangle" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util bubble-close",
                      staticStyle: { float: "right" },
                      on: {
                        click: function($event) {
                          return _vm.cancelGuide()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bubble-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.leftBanner.addCloudText")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "bubble-button",
                        on: {
                          click: function($event) {
                            return _vm.cancelGuide()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.done")))]
                    )
                  ])
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        (_vm.topNavIndex == 1 || _vm.topNavIndex == 0) && _vm.widthNav
          ? _c("div", { staticStyle: { "flex-grow": "1" } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "driveMenu",
            staticClass: "drive-menu",
            attrs: { id: "driveMenu" }
          },
          [
            (_vm.topNavIndex == 1 || _vm.topNavIndex == 0) && _vm.widthNav
              ? _c("div", { staticClass: "manage_clouds_text" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$store.state.isLiteMode
                          ? _vm.$t("language.leftBanner.manageClouds2")
                          : _vm.$t("language.leftBanner.manageClouds")
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            (_vm.topNavIndex == 1 || _vm.topNavIndex == 0) && _vm.widthNav
              ? _c(
                  "div",
                  {
                    staticClass: "manage_clouds_add",
                    class: _vm.isAddCloudAndEmail ? "manage_clouds_select" : "",
                    on: {
                      click: function($event) {
                        return _vm.menuOptionSelect(901)
                      }
                    }
                  },
                  [
                    _c("div"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$store.state.isLiteMode
                            ? _vm.$t("language.leftBanner.addCloud")
                            : _vm.$t("language.leftBanner.addEmail")
                        )
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-scrollbar",
              {
                ref: "driveScrollbar",
                class: _vm.editShow || _vm.editNameId ? "not-scroll" : "",
                staticStyle: {
                  position: "absolute",
                  width: "-webkit-fill-available",
                  height: "100%"
                },
                style: _vm.driveMenuHeight
              },
              [
                _c(
                  "div",
                  { ref: "driveMenuOptions", staticClass: "menu-options" },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.$store.state.isLiteMode &&
                              (((_vm.topNavIndex == 1 ||
                                _vm.topNavIndex == 0) &&
                                _vm.widthNav) ||
                                (_vm.topNavIndex != 1 && _vm.topNavIndex != 0)),
                            expression:
                              "$store.state.isLiteMode && (((topNavIndex==1||topNavIndex==0) && widthNav) || (topNavIndex!=1&&topNavIndex!=0))"
                          }
                        ],
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.menuOptionSelect(108)
                          }
                        }
                      },
                      [
                        _c("LiteDrive", {
                          on: {
                            noneDrive: function($event) {
                              return _vm.noneDrive2()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.clouds, function(cloud, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.$store.state.isLiteMode &&
                                (((_vm.topNavIndex == 1 ||
                                  _vm.topNavIndex == 0) &&
                                  _vm.widthNav) ||
                                  (_vm.topNavIndex != 1 &&
                                    _vm.topNavIndex != 0)),
                              expression:
                                "!$store.state.isLiteMode && (((topNavIndex==1||topNavIndex==0) && widthNav) || (topNavIndex!=1&&topNavIndex!=0))"
                            }
                          ],
                          key: cloud.id,
                          ref: "driveMenu-" + cloud.id,
                          refInFor: true,
                          staticClass: "menu-option",
                          class:
                            cloud.id == _vm.menuClickCurrent
                              ? "menu-option-select"
                              : "",
                          style: _vm.hideEmail(cloud) ? "display: none;" : "",
                          attrs: {
                            "data-id": cloud.id,
                            "data-type": cloud.appName,
                            "data-index": index
                          },
                          on: {
                            mouseenter: function($event) {
                              return _vm.handleMouseEnter(cloud)
                            },
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.editDriveMenushow($event, index, cloud)
                            },
                            click: function($event) {
                              return _vm.addDriveSelect(cloud.id, cloud, false)
                            }
                          }
                        },
                        [
                          (_vm.topNavIndex == 1 || _vm.topNavIndex == 0) &&
                          _vm.widthNav
                            ? _c("div", {
                                staticClass: "option-more-icon",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.editDriveMenushow(
                                      $event,
                                      index,
                                      cloud
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.topNavIndex == 1 || _vm.topNavIndex == 0) &&
                          _vm.widthNav
                            ? _c("div", { staticClass: "option-left" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "option-icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/images/drive/logo/" +
                                  cloud.appName +
                                  ".svg")
                              }
                            })
                          ]),
                          _vm._v(" "),
                          cloud.id != _vm.editNameId
                            ? _c(
                                "div",
                                {
                                  staticClass: "option-name",
                                  attrs: { title: cloud.name }
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(cloud.name))]),
                                  _vm._v(" "),
                                  (_vm.topNavIndex == 1 ||
                                    _vm.topNavIndex == 0) &&
                                  _vm.widthNav
                                    ? _c(
                                        "span",
                                        { staticClass: "option-desc" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              cloud.desc
                                                ? cloud.desc
                                                : _vm.$t("language.common.load")
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option-email-btn",
                                      style: _vm.bubbleStyle3
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "task-icon googlePhotos_big"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "option-email" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                cloud.driveInfo.authAccountId
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "option-btn" }, [
                                        _c(
                                          "button",
                                          {
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.handleDisconnect(
                                                  $event,
                                                  index,
                                                  cloud
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Disconnect from Google Photos"
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "edit-outclass",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.isflage = true
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "edit-innerclass" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editName,
                                            expression: "editName"
                                          }
                                        ],
                                        ref: "editInput-" + cloud.id,
                                        refInFor: true,
                                        staticClass: "drive-name-edit",
                                        domProps: { value: _vm.editName },
                                        on: {
                                          focus: function($event) {
                                            _vm.isflage = true
                                          },
                                          blur: function($event) {
                                            return _vm.submitDriveName(
                                              cloud,
                                              index
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.editName = $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "drive-input-icon" },
                                        [
                                          _c("i", {
                                            staticClass: "icon-util name-sure",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.submitDriveName(
                                                  cloud,
                                                  index
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon-util name-cancel ",
                                            on: {
                                              mousedown: function($event) {
                                                $event.stopPropagation()
                                                return _vm.cancelEditDriveName(
                                                  cloud,
                                                  index
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editShow,
                            expression: "editShow"
                          },
                          {
                            name: "clickoutside",
                            rawName: "v-clickoutside",
                            value: _vm.editDrivesMenusClose,
                            expression: "editDrivesMenusClose"
                          }
                        ],
                        staticClass: "edit-drives-menus",
                        attrs: { id: "editDrivesMenus" },
                        on: {
                          mouseout: function($event) {
                            _vm.selectCloud = null
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "edit-drive-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.editDriveName()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                " rename edit-drive-position new-position"
                            }),
                            _vm._v(" "),
                            _c("div", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(_vm.$t("language.common.rename")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "edit-drive-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.rewriteDrive()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                "icon-util edit-small edit-drive-position"
                            }),
                            _vm._v(" "),
                            _c("div", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(_vm.$t("language.leftBanner.edit")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "edit-drive-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.removeDialogShow()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                " delete edit-drive-position new-position"
                            }),
                            _vm._v(" "),
                            _c("div", { staticStyle: { float: "left" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.isEditGooglePhotosV2
                                    ? "Disconnect"
                                    : _vm.$t("language.leftBanner.remove")
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "edit-drive-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.propertiesDialogShow()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                " properties edit-drive-position new-position",
                              staticStyle: { left: "1Px" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticStyle: { float: "left" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.properties"))
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  2
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "footer-menu menu-options",
            attrs: { id: "footerMenu" }
          },
          [
            _c("promo-countdown", {
              attrs: { "end-time": _vm.promoEndTime },
              on: {
                "countdown-end": _vm.handlePromoCountdownEnd,
                "click-promo": _vm.handlePromoClick
              }
            }),
            _vm._v(" "),
            false
              ? _c(
                  "div",
                  {
                    staticClass: "menu-option",
                    class:
                      9 == _vm.menuClickCurrent ? "menu-option-select" : "",
                    on: {
                      click: function($event) {
                        return _vm.menuOptionSelect(9)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "icon ap_green_title" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-name" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("language.affiliateProgram.leftTitle")
                          ) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            false
              ? _c(
                  "div",
                  {
                    staticClass: "menu-option",
                    class:
                      12 == _vm.menuClickCurrent ? "menu-option-select" : "",
                    on: {
                      click: function($event) {
                        return _vm.menuOptionSelect(12)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "icon if_Invite_friends" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-name" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("language.leftBanner.inviteFriends")) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showLiteSwitch
              ? _c("div", { staticClass: "lite_switch_span" })
              : _vm._e(),
            _vm._v(" "),
            _vm.showLiteSwitch
              ? _c(
                  "div",
                  {
                    staticClass: "menu-option",
                    on: {
                      click: function($event) {
                        return _vm.liteSwitch()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "icon lite_switch" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-name" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$store.state.isLiteMode
                              ? "Switch to MultCloud Classic"
                              : "Switch to MultCloud Plus"
                          ) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("propertiesDialog", {
        ref: "propertiesDialog",
        attrs: {
          cloudName: _vm.cloudName,
          cloudId: _vm.cloudId,
          cloud: _vm.cloud
        }
      }),
      _vm._v(" "),
      _c("removeDialog", {
        ref: "removeDialog",
        attrs: { cloudId: _vm.cloudId }
      }),
      _vm._v(" "),
      _c("editCloudDialog", {
        ref: "editCloudDialog",
        attrs: { cloudType: _vm.cloudName, cloudId: _vm.cloudId }
      }),
      _vm._v(" "),
      _c("editFtpDialog", { ref: "editFtpDialog" }),
      _vm._v(" "),
      _c("editNasDialog", { ref: "editNasDialog" }),
      _vm._v(" "),
      _c("userStarPopup", { ref: "userStarPopup" }),
      _vm._v(" "),
      _c("userStarJumpPopup", { ref: "userStarJumpPopup" }),
      _vm._v(" "),
      _c("userStarFeedbackPopup", { ref: "userStarFeedbackPopup" }),
      _vm._v(" "),
      _vm.$store.state.showWebsiteGuideMask
        ? _c("div", { staticClass: "guide_mask" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8536b60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8536b60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/left_banner.vue
// module id = null
// module chunks = 